var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block time-tracking"},[_c('issuable-time-tracker',{attrs:{"full-path":_vm.fullPath,"issuable-id":_vm.issuableId,"issuable-iid":_vm.issuableIid,"limit-to-hours":_vm.limitToHours,"can-add-time-entries":_vm.canAddTimeEntries,"can-set-time-estimate":_vm.canSetTimeEstimate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }